import React from 'react'

function AddStatus() {
  return (
    <div>
      
    </div>
  )
}

export default AddStatus
